module.exports = __webpack_public_path__ + "img/dealer.5c7c34c9.svg";